import React from "react";
import ProductsSection from "../Home/ProductsSection.jsx";

const ProductsPage = () => <ProductsSection />;

export default ProductsPage;
